import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_OutcomeMeasures = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_OutcomeMeasures' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <h4>Performance Outcome Measure Form (FASAMS)
                            <br /> Lutheran Services Florida</h4>
                    </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date of Service:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Staff Person:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateOfService' name='txtDateOfService' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtStaffPerson' name='txtStaffPerson' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b> Client Demographic </b></p>

                <p className='w-750'> <span className='eleHeader'>1. Veteran Status</span>
                    <ul>
                        <li>
                            1 for Veteran
                        </li>
                        <li>
                            2 for Not a Veteran
                        </li>
                        <li>
                            7 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtVeteranStatus' name='txtVeteranStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>2. Marital Status </span>
                    <ul>
                        <li>
                            1 for Single (includes individuals whose only
                            marriage was annulled)
                        </li>
                        <li>
                            2 for Married (includes individuals living as married
                            under official common law)
                        </li>
                        <li>
                            3 for Widowed
                        </li>
                        <li>
                            4 for Divorced
                        </li>
                        <li>
                            5 for Separated
                        </li>
                        <li>
                            6 for Unreported
                        </li>
                        <li>
                            7 for Registered Domestic Partner
                        </li>
                        <li>
                            8 for Legally Separated
                        </li>
                    </ul>
                    <input type='text' id='txtMaritalStatus' name='txtMaritalStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>3. Residence County </span>
                    <ul>
                        <li>
                            County of the physical address in which the individual resides.
                        </li>
                        <li>
                            Duval, Nassau
                        </li>
                    </ul>
                    <input type='text' id='txtResidenceCounty' name='txtResidenceCounty' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>4. Residence Postal </span>
                    The postal code of the individual's home residence. <br />
                    <input type='text' id='txtResidencePostal' name='txtResidencePostal' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>5. Primary Income Source </span>
                    <ul>
                        <li>
                            1 for Salary - Compensation for services, paid to the individual on a regular basis.
                        </li>
                        <li>
                            2 for TANF - Income received by the individual through the Temporary Assistance to Needy Families Program.
                        </li>
                        <li>
                            3 for Retirement/Pension/SSI - Income received by the individual for fulfilling certain conditions of prior employment.
                        </li>
                        <li>
                            4 for Disability - Income received by the individual, usually from government or insurance sources, for prior handicapping conditions. This includes SSDI.
                        </li>
                        <li>
                            5 for Other - Non-specified income including illegal income child support, and alimony.
                        </li>
                        <li>
                            6 for None - Individual has no source of income.
                        </li>
                        <li>
                            7 for Unknown - Use this code if you can't determine the source of the individual's income.
                        </li>
                    </ul>
                    <input type='text' id='txtPrimaryIncomeSource' name='txtPrimaryIncomeSource' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>6. Annual Personal Income Amount </span>
                    Indicate the individual's annual personal income. For example, if the individual makes $30,000 per year, then enter 30000.00. <br />
                    <input type='text' id='txtAnnualPersonalIncome' name='txtAnnualPersonalIncome' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>7. Annual Family Income Amount </span>
                    <ul>
                        <li>
                            Indicate the individual's family's annual income. For example, if the individual makes $30,000 per year, and the spouse makes $30,000 per year, then enter 60000.00.
                        </li>
                        <li>
                            Annual Family Income is the total compensation received by all family members living in the same household. Compensation may include wages, social security and child support. A family includes an individual and their dependents (if any) or a couple (married, common law or life partners) that live together and their dependents (if any). This does not include a couple legally married but living separately.
                        </li>
                    </ul>
                    <input type='text' id='txtAnnualFamilyIncome' name='txtAnnualFamilyIncome' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>8. Primary Payment Source </span>
                    <b>Must be one of the following values:</b>
                    <ul>
                        <li>
                            1 for Self-Pay
                        </li>
                        <li>
                            2 for Blue Cross/Blue Shield
                        </li>
                        <li>
                            3 for Medicare
                        </li>
                        <li>
                            4 for Medicaid
                        </li>
                        <li>
                            5 for Other Government Payments
                        </li>
                        <li>
                            6 for Worker's Compensation
                        </li>
                        <li>
                            7 for Other Health Insurance Companies
                        </li>
                        <li>
                            8 for No Charge
                        </li>
                        <li>
                            9 for Other
                        </li>
                        <li>
                            10 for Tricare/Veterans
                        </li>
                        <li>
                            11 for Kidcare/Childrens' Health Insurance Program (CHIP)
                        </li>
                        <li>
                            12 for DCF
                        </li>
                        <li>
                            97 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtPrimaryPaymentSource' name='txtPrimaryPaymentSource' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>9. Disability Income Status </span>
                    Indicate whether the individual is receiving disability income for a psychiatric condition. <br />
                    <b>Must be one of the following values:</b>
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtDisabilityIncome' name='txtDisabilityIncome' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>10. Health Insurance </span>
                    ndicate the individual's health insurance. The insurance may or may not cover behavioral health. <br />
                    <b>Must be one of the following values:</b>
                    <ul>
                        <li>
                            1 for Private Insurance (other than Blue Cross/Blue Shield or an HMO)
                        </li>
                        <li>
                            2 for Blue Cross/Blue Shield
                        </li>
                        <li>
                            3 for Medicare
                        </li>
                        <li>
                            4 for Medicaid
                        </li>
                        <li>
                            5 for Tricare/Veterans
                        </li>
                        <li>
                            6 for Health Maintenance Organization (HMO)
                        </li>
                        <li>
                            7 for Kidcare/Children's Health Insurance Program (CHIP)
                        </li>
                        <li>
                            20 for Other
                        </li>
                        <li>
                            21 for None
                        </li>
                        <li>
                            97 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtHealthInsurance' name='txtHealthInsurance' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>11. TANF </span>
                    Indicate the individual's status for receiving Temporary Assistance for Needy Families (TANF) funds.
                    <ul>
                        <li>
                            1 for Temporary Cash Assistance
                        </li>
                        <li>
                            2 for Diversion Family Program
                        </li>
                        <li>
                            3 for Not an individual receiving TANF
                        </li>
                        <li>
                            4 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtTanf' name='txtTanf' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>12. Number of Dependents </span>
                    Indicate the number of people dependent on the individual.
                    <ul>
                        <li>
                            Must be '1' if the dependents count is not known.
                        </li>
                    </ul>
                    <input type='text' id='txtNumberOfDependents' name='txtNumberOfDependents' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>13. Family Size </span>
                    Indicate the number of family members living in the individual's
                    household.
                    <ul>
                        <li>
                            Must be '-1' if the family size is not known.
                        </li>
                    </ul>
                    A family includes an individual and their dependents (if any) or a
                    couple (married, common law or life partners) that live together and their dependents (if any). This does not include a couple legally married but living separately. <br />
                    <input type='text' id='txtFamilySize' name='txtFamilySize' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>14. Children Dependents </span>
                    Indicate if there are children dependent on the individual.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtChildrenDependents' name='txtChildrenDependents' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>15. Child Welfare Involved </span>
                    Indicate if Child Welfare is involved with the individual.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtChildWelfareInvolved' name='txtChildWelfareInvolved' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>16. Pregnant </span>
                    Indicate whether a female individual is pregnant.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            6 for Not Applicable (Male)
                        </li>
                    </ul>
                    <input type='text' id='txtPregnant' name='txtPregnant' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>17. Pregnancy Trimester </span>
                    Indicate the trimester of a female individual's pregnancy.
                    <ul>
                        <li>
                            1 for 1st trimester
                        </li>
                        <li>
                            2 for 2nd trimester
                        </li>
                        <li>
                            3 for 3rd trimester
                        </li>
                        <li>
                            4 for Not pregnant or male
                        </li>
                        <li>
                            5 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtPregnancyTrimester' name='txtPregnancyTrimester' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>18. Recently Become Postpartum </span>
                    Indicate if a female individual has recently become postpartum by giving birth to a child within the last 91 days
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                        <li>
                            6 for Not Applicable
                        </li>
                    </ul>
                    <input type='text' id='txtPostpartum' name='txtPostpartum' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>19. Expected Delivery Date </span>
                    Indicate the expected date of delivery.
                </p>
                <p className='w-250'> <input type='date' id='txtDeliveryDate' name='txtDeliveryDate' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>20. Birth Outcome </span>
                    Indicate the pregnancy's birth outcome at discharge for a female individual that was pregnant within the admission and discharge dates.
                    <ul>
                        <li>
                            1 for Live birth (drug presence in newborn)
                        </li>
                        <li>
                            2 for Live birth (no drug presence in newborn)
                        </li>
                        <li>
                            3 for Still birth
                        </li>
                        <li>
                            4 for Miscarriage
                        </li>
                        <li>
                            5 for Pregnancy terminated
                        </li>
                        <li>
                            6 for Not yet delivered
                        </li>
                        <li>
                            7 for Unknown Birth Outcome (an option only if whereabouts of individual is unknown)
                        </li>
                        <li>
                            8 for Not Applicable Is to be 8 if the individual's gender is
                            male.
                        </li>
                    </ul>
                    <input type='text' id='txtBirthOutcome' name='txtBirthOutcome' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>21. Actual Delivery Date </span>
                    The date indicating actual delivery date.
                </p>
                <p className='w-250'> <input type='date' id='txtActualDeliveryDate' name='txtActualDeliveryDate' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>22. Birth Weight Pounds </span>
                    Indicate the birth weight in pounds.
                </p>
                <p className='w-250'> <input type='date' id='txtBirthWeightPounds' name='txtBirthWeightPounds' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>23. Birth Weight Ounces </span>
                    The number indicating the birth weight in ounces.
                </p>
                <p className='w-250'> <input type='date' id='txtBirthWeightOunces' name='txtBirthWeightOunces' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>24. Drug Free At Delivery </span>
                    Indicate whether the individual was drug free at time of delivery if the individual was pregnant at any time during episode of care.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown (use only if whereabouts of individual is unknown)
                        </li>
                        <li>
                            6 for Not Applicable
                        </li>
                    </ul>
                    <input type='text' id='txtDrugFree' name='txtDrugFree' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>25. Americans With Disabilities Act Disabled Status </span>
                    Indicate whether the individual meets the definition of “disabled” under the Americans with Disabilities Act (ADA), e.g., developmentally disabled, physically disabled, visually impaired, hearing impaired, non-ambulatory, or English Language impaired.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtDisabilities' name='txtDisabilities' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>26. Unable To Perform Daily Living Activities </span>
                    Indicate if the individual is unable to perform activities of daily living functioning independently.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtLivingActivities' name='txtLivingActivities' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>27. Intravenous Substance History </span>
                    Indicate if the individual has a history of intravenous substance use.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtIntravenous' name='txtIntravenous' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>28. Education Grade Level </span>
                    Indicate either the highest school grade completed for adults or children not atending school or the current school grade for school-age children (3-17 years old) atending school. 
                    <input type='text' id='txtEducationGrade' name='txtEducationGrade' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-210'>
                            <ul>

                                <li>
                                    00 No Years of Schooling
                                </li>
                                <li>
                                    01 Grade 1
                                </li>
                                <li>
                                    02 Grade 2
                                </li>
                                <li>
                                    03 Grade 3
                                </li>
                                <li>
                                    04 Grade 4
                                </li>
                                <li>
                                    05 Grade 5
                                </li>
                                <li>
                                    06 Grade 6
                                </li>
                                <li>
                                    07 Grade 7
                                </li>
                                <li>
                                    08 Grade 8
                                </li>
                                <li>
                                    24 Grade 9
                                </li>
                                <li>
                                    25 Grade 10
                                </li>
                                <li>
                                    26 Grade 11
                                </li>
                                <li>
                                    27 Grade 12
                                </li>
                            </ul>
                        </td>
                        <td className='w-250'>
                            <ul>
                                <li>
                                    28 High School Graduate (Diploma/GED)
                                </li>
                                <li>
                                    30 Associate Degree
                                </li>
                                <li>
                                    31 Bachelor's degree
                                </li>
                                <li>
                                    32 Master's degree
                                </li>
                                <li>
                                    33 Professional Degree
                                </li>
                                <li>
                                    34 Doctorate Degree
                                </li>
                                <li>
                                    35 Special School
                                </li>
                                <li>
                                    36 Vocational School
                                </li>

                            </ul>
                        </td>
                        <td className='w-250'>
                            <ul>

                                <li>
                                    37 College Undergraduate Freshman
                                </li>
                                <li>
                                    38 College Undergraduate Sophomore
                                </li>
                                <li>
                                    39 College Undergraduate Junior
                                </li>
                                <li>
                                    40 College Undergraduate Senior
                                </li>
                                <li>
                                    41 Kindergarten
                                </li>
                                <li>
                                    42 Nursery School/Preschool/Head Start
                                </li>
                                <li>
                                    43 Unknown
                                </li>
                            </ul>

                        </td>
                    </tr>

                </table>

                <p className='w-750'> <span className='eleHeader'>29. School Attendance Status </span>
                    Indicate the school attendance status of school-age children and adolescents (3-17 years old), including young adults (18-21 years old) who are protected under the Individuals with Disabilities Education Act (IDEA), receiving mental health services.
                    <ul>
                        <li>
                            0 for No - individual has not attended school at any time in the past 3 months
                        </li>
                        <li>
                            1 for Yes - individual has attended school at any time in the past 3 months
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                        <li>
                            6 for Not Applicabl
                        </li>
                    </ul>
                    <input type='text' id='txtSchoolAtendance' name='txtSchoolAtendance' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>30.  School Days Available In Last 90 Days Number </span>
                    Indicate the number of school days available within the last 90 days.
                    <ul>
                        <li>
                            Must be a valid integer between 0 and 90 if the school days
                            available in the last 90 days is known.
                        </li>
                        <li>
                            Must be '1' if the school days available in the last 90 days is not known.
                        </li>
                    </ul>
                    <input type='text' id='txtDaysAvailable' name='txtDaysAvailable' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>31. School Days Attended In Last 90 Days Number </span>
                    Indicate the number of school days attended within the last 90 days.
                    <ul>
                        <li>
                            Must be a valid integer between 0 and 90 if the school days attended in the last 90 days is known.
                        </li>
                        <li>
                            Must be '1' if the school days attended in the last 90 days is not Known.
                        </li>
                    </ul>
                    <input type='text' id='txtDaysAtended' name='txtDaysAtended' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>32. School Suspension/Expulsion Status </span>
                    Indicate if the child was suspended or expelled from school
                    within the last 30 days
                    <ul>
                        <li>
                            0 for Neither Suspended nor Expelled
                        </li>
                        <li>
                            1 for Suspended
                        </li>
                        <li>
                            2 for Expelled
                        </li>
                        <li>
                            3 for Suspended and Expelled
                        </li>
                        <li>
                            4 for Not Applicable
                        </li>
                    </ul>
                    <input type='text' id='txtExpulsionStatus' name='txtExpulsionStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>33. Employment Status </span>
                    Indicate the individual's employment status.
                    <ul>
                        <li>
                            10 Active military, overseas
                        </li>
                        <li>
                            20 Active military, USA
                        </li>
                        <li>
                            30 Full Time
                        </li>
                        <li>
                            31 Unpaid Family Worker - Family member who works at least 15 hours or more a week without pay in a family-operated enterprise.
                        </li>
                        <li>
                            40 Part Time
                        </li>
                        <li>
                            50 Leave of Absence
                        </li>
                        <li>
                            60 Retired
                        </li>
                    </ul>
                    <input type='text' id='txtEmploymentStatus' name='txtEmploymentStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>34. Days Worked In Last 30 Days Number </span>
                    Indicate the number of days the individual worked for pay,
                    including paid leave, within the last 30 days.
                    <ul>
                        <li>
                            Must be a valid integer between 0 and 30 if the days worked in the last 30 is not known.
                        </li>
                        <li>
                            Must be '1' if the days worked in the last 30 days is not known.
                        </li>
                    </ul>
                    <input type='text' id='txtDaysWorked' name='txtDaysWorked' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>35. Days Spent In Community In Last 30 Days </span>
                    Indicating the number of days the individual spent in the community, within the last 30 days.
                    <ul>
                        <li>
                            Must be a valid integer between 0 and 30 if the days spent in the community in the last 30 days is known.
                        </li>
                        <li>
                            Must be '1' if the days spent in the community in the last 30 days is not known.
                        </li>
                    </ul>
                    <input type='text' id='txtDaysSpent' name='txtDaysSpent' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>36. Living Arrangement Code </span>
                    Indicate whether the individual is homeless, a dependent (living with parents or in a supervised setting) or living independently on his or her own.
                    <ul>
                        <li>
                            01 Independent Living - Alone
                        </li>
                        <li>
                            02 Independent Living - with Relatives
                        </li>
                        <li>
                            03 Independent Living - with Non-Relatives Dependent Living means the individual is paying less than an estimated equal share amount of the total combined living expenses.
                        </li>
                        <li>
                            04 Dependent Living - with Relatives Other Living Arrangements
                        </li>
                        <li>
                            05 Dependent Living - with Non-Relatives
                        </li>
                        <li>
                            06 Assisted Living Facility (ALF)
                        </li>
                        07 Foster Care/Home
                        <li>
                            08 Adult Residential Treatment Facility (Group Home)
                        </li>
                        <li>
                            09 Homeless
                        </li>
                        <li>
                            10 State Mental Health Treatment Facility (State Hospital)
                        </li>
                        <li>
                            11 Nursing Home
                        </li>
                        <li>
                            12 Supported Housing
                        </li>
                        <li>
                            13 Correctional Facility
                        </li>
                        <li>
                            14 DJJ Facility
                        </li>
                        <li>
                            15 Crisis Residence
                        </li>
                        <li>
                            16 Children Residential Treatment Facility
                        </li>
                        <li>
                            17 Limited Mental Health Licensed ALF
                        </li>
                        <li>
                            18 Other Residential Status
                        </li>
                        <li>
                            99 Not Available or Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtLivingArrangement' name='txtLivingArrangement' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>37. Self Help Group Attendance Frequency </span>
                    Indicate the frequency of attendance in a self-help or mutual support group in the last 30 days.
                    <ul>
                        <li>
                            1 for No attendance
                        </li>
                        <li>
                            2 for Less than once a week - 1 to 3 times in the past 30 days
                        </li>
                        <li>
                            3 for About once a week - 4 to 7 times in the past 30 days
                        </li>
                        <li>
                            4 for 2 to 3 times per week - 8-15 times in the past 30 days
                        </li>
                        <li>
                            5 for At least 4 times a week - 16 to 30 times in past 30 days
                        </li>
                        <li>
                            6 for Some attendance - Number of times and frequency is unknown
                        </li>
                        <li>
                            97 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtAtendanceFrequency' name='txtAtendanceFrequency' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>38. Primary Disorder </span>
                    Indicate the rank or priority of the individual's substance use disorder.
                    <ul>
                        <li>
                            1 for Primary
                        </li>
                        <li>
                            2 for Secondary
                        </li>
                        <li>
                            3 for Tertiary
                        </li>
                    </ul>
                    Individuals with mental health problems do not have to report any substance use disorders but may if the individual is being treated for co-occurring mental health and substance use needs. <br />
                    <input type='text' id='txtPrimaryDisorder' name='txtPrimaryDisorder' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>39. Disorder Code </span>
                    Indicate the individual's substance use disorder for the given rank order. (Pamphlet155-2 for complete list)
                    <ul>
                        <li>
                            01 None
                        </li>
                        <li>
                            02 Alcohol Alcohol
                        </li>
                        <li>
                            03 Stimulants Crack Cocaine (Use Smoking For Route)
                        </li>
                        <li>
                            04 Hallucinogens - Psychedelics Marijuana/Hashish
                        </li>
                        <li>
                            05 Opiates And Opioids Heroin
                        </li>
                        <li>
                            06 Opiates And Opioids Non-Prescription Methadone
                        </li>
                        <li>
                            07 Opiates And Opioids Other Opiates Or Opioids
                        </li>
                        <li>
                            08 Hallucinogens - Psychedelics Pcp-Phencyclidine
                        </li>
                        <li>
                            09 Hallucinogens - Psychedelics Other Hallucinogens/Psychedelics
                        </li>
                        <li>
                            10 Stimulants Methamphetamines
                        </li>
                        <li>
                            11 Stimulants Other Amphetamines
                        </li>
                        <li>
                            12 Stimulants Other Stimulants
                        </li>
                        <li>
                            98 Not Classified As Prescription Or Non Prescription Presenting At-Risk
                        </li>
                        <li>
                            99 Not Classified As Prescription Or Non Prescription
                            Presenting Substance Abuse Problem, Not Confirmed
                        </li>
                    </ul>
                    <input type='text' id='txtDisorderCode' name='txtDisorderCode' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>40. Route Of Administration </span>
                    Indicate the usual route of administration of the corresponding substance with which the individual has a disorder.
                    <ul>
                        <li>
                            1 for Oral
                        </li>
                        <li>
                            2 for Smoking
                        </li>
                        <li>
                            3 for Inhalation
                        </li>
                        <li>
                            4 for Injection (IV or Intra-muscular)
                        </li>
                        <li>
                            5 for Other Route
                        </li>
                        <li>
                            7 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtRouteOfAdministration' name='txtRouteOfAdministration' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>41. Frequency of Use </span>
                    Indicate the frequency of use of the corresponding substance with which the individual has a disorder.
                    <ul>
                        <li>
                            1 for No Use in Past 30 days
                        </li>
                        <li>
                            2 for 1-3 Times in Past 30 days
                        </li>
                        <li>
                            3 for 1-2 Times per Week
                        </li>
                        <li>
                            4 for 3-6 Times per Week
                        </li>
                        <li>
                            5 for Daily
                        </li>
                        <li>
                            7 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtFrequencyOfUse' name='txtFrequencyOfUse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>42. First Use Age </span>
                    For substances other than alcohol, this number indicates the age at which the individual first used the corresponding substance with which
                    the individual has a disorder. <br />
                    <input type='text' id='txtFirstUseAge' name='txtFirstUseAge' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>43. Mental Health Problem Risk </span>
                    Indicate if the individual shows evidence of stress and/or mental health problems.
                    <ul>
                        <li>
                            0 for None
                        </li>
                        <li>
                            1 for Shows evidence of recent severe stressful event and problems with coping.
                        </li>
                        <li>
                            2 for Displays symptomatology placing person at risk of more restrictive intervention if untreated.
                        </li>
                        <li>
                            3 for Both 1 and 2
                        </li>
                        <li>
                            7 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtMentalHealthProblem' name='txtMentalHealthProblem' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>44. Has Risk Factors For Emotional Disturbance </span>
                    Indicate if the child has risk factors for Emotional Disturbance (homelessness, family history of mental illness, abuse or neglect, exposure to domestic violence, substance use, chronic or serious physical illness, or multiple out-of-home placements).
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            Is to be 0 (No) or not provided if the individual is an adult
                        </li>
                    </ul>
                    <input type='text' id='txtEmotionalDisturbance' name='txtEmotionalDisturbance' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>45. Prognosis Status </span>
                    Indicate if the individual received services for the current mental health problem within the past 12 months or if the mental health problem is expected to persist for at least another 12 months.
                    <ul>
                        <li>
                            0 for No (if both conditions are not met)
                        </li>
                        <li>
                            1 for Yes (if either or both conditions are met)
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtPrognosisStatus' name='txtPrognosisStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>46. Medication Assisted Opioid Therapy </span>
                    Indicate whether the use of opioid medications such as methadone or buprenorphine are part of the individual's treatment plan.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtMedicationAssisted' name='txtMedicationAssisted' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>47. Taking Antipsychotic Medication </span>
                    Indicate whether the individual has been taking any atypical antipsychotic medication.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtAntipsychoticMedication' name='txtAntipsychoticMedication' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>48. Received Prescriptions Through Indigent Drug Program </span>
                    Indicate whether the individual received medication through the Indigent Drug Program (IDP) within the last 90 days.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    <input type='text' id='txtIndigentDrug' name='txtIndigentDrug' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>49. Received Prescriptions Through Patient Assistance Program </span>
                    Indicate whether the individual received atypical antipsychotic medication through the Patient Assistance Program (PAP).
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtPatientAssistance' name='txtPatientAssistance' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>50. Legal Status </span>
                    Indicate the individual's legal status.
                    <ul>
                        <li>
                            1 for Voluntary-self
                        </li>
                        <li>
                            2 for Voluntary-others (parents, guardians, etc.)
                        </li>
                        <li>
                            3 for Involuntary-civil
                        </li>
                        <li>
                            4 for Involuntary-criminal
                        </li>
                        <li>
                            5 for Involuntary-juvenile justice
                        </li>
                        <li>
                            6 for Involuntary-civil, sexual
                        </li>
                        <li>
                            97 for Unknown
                        </li>
                    </ul>
                    Codes 1 and 2 may be used only if Is Voluntarily In Treatment is 1 (Yes) <br />
                    Codes 3, 4, 5 and 6 may be used only if Is Voluntarily In Treatment <br />
                    Code is 0 (No)
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            Is to be 0 (No) or not provided if the individual is an adult.
                        </li>
                    </ul>
                    <input type='text' id='txtLegalStatus' name='txtLegalStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>51. Is Legally Incompetent Code </span>
                    Indicate if the individual has been deemed legally incompetent.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    Yes would indicate that the individual has been deemed legally incompetent. <br />
                    No would indicate that the individual has not been deemed legally incompetent. <br />
                    <input type='text' id='txtLegallyIncompetent' name='txtLegallyIncompetent' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>52. Legal Guardian Relationship </span>
                    Indicate the type of legal guardianship for the child.
                    <ul>
                        <li>
                            1 for Parent
                        </li>
                        <li>
                            2 for Other Relative
                        </li>
                        <li>
                            3 for Non-relative
                        </li>
                        <li>
                            4 for Emancipated minor
                        </li>
                        <li>
                            5 for State or public agency
                        </li>
                        <li>
                            6 for Not Applicable
                        </li>
                    </ul>
                    <input type='text' id='txtLegalGuardian' name='txtLegalGuardian' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>53. Competency Status </span>
                    Indicate an individual's competency or incompetency. Competent indicates the status of an individual who has not been deemed incompetent by court order. Incompetent indicates the status of an individual who has been deemed incompetent to proceed in a criminal proceeding, adjudicated incapacitated, or deemed incompetent by court order.
                    <ul>
                        <li>
                            1 for The individual is not under the jurisdiction of the court and is not involved in criminal justice system
                        </li>
                        <li>
                            2 for The individual is deemed by the court to be competent to proceed in criminal offenses and is not adjudicated "Not Guilty by Reason of Insanity"
                        </li>
                        <li>
                            3 for The individual is adjudicated by the court as incompetent to proceed (ITP) at a material stage of a criminal proceeding
                        </li>
                        <li>
                            4 for The individual is adjudicated by the court as "Not Guilty by Reason of Insanity" on criminal charges
                        </li>
                        <li>
                            5 for Other (None of the above)
                        </li>
                        <li>
                            6 for Rubio
                        </li>
                        <li>
                            7 for Mosher
                        </li>
                        <li>
                            97 for Unknown
                        </li>
                    </ul>
                    Code 3 may be used only if Is Legally Incompetent Code is 1 (Yes). <br />
                    <input type='text' id='txtCompetencyStatus' name='txtCompetencyStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>54. Has Been Commited To Juvenile Justice </span>
                    Indicate if the child was commited or recommited to DCF of Juvenile Justice (DJJ).
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    Is to be 0 (No) or not provided if the individual is an adult. <br />
                    <input type='text' id='txtJuvenileJustice' name='txtJuvenileJustice' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>55. Children Dependency Or Delinquency </span>
                    Indicate the status of children who are adjudicated or non-adjudicated as dependent and/or delinquent.
                    <ul>
                        <li>
                            01 Children Adjudicated as Delinquent, in physical custody A delinquent youth in the physical custody of the Department of Juvenile Justice, who is commited to a DJJ facility.
                        </li>
                        <li>
                            02 Children Adjudicated as Delinquent, not in physical custody A delinquent youth not in the physical custody Department of
                            Juvenile Justice, who is living in the community and not a DJJ facility
                        </li>
                        <li>
                            03 Children Adjudicated as Dependent, in licensed out of home care A dependent child in the physical custody of the Department, to include such placements as foster and group homes, emergency shelter, and therapeutic placements.
                        </li>
                        <li>
                            04 Children Adjudicated as Dependent, not in licensed out of home care A dependent child not in the physical custody of the
                            Department and not in licensed out of home care.
                        </li>
                        <li>
                            05 Children Adjudicated as Dependent & Delinquent, in physical custody The child meets codes 01 and 03 above.
                        </li>
                        <li>
                            06 Children Adjudicated as Dependent & Delinquent, not in physical custody The child meets codes 02 and 04 above
                        </li>
                        <li>
                            07 Children Adjudicated as “Children in Need of Services” (CINS) A child in need of services with no pending departmental investigation into suspicion of abuse, neglect or delinquent; or no current supervision by the department for adjudication for dependency or delinquency. Child must be determined by the court to be a persistent runaway, habitual truant, or to have persistently disobeyed the reasonable/lawful demands of parent or legal guardians, pursuant to Chapter 39, F.S.
                        </li>
                        <li>
                            08 Children Emancipated by a Court of Law Individual under age 18 who, through a court process, becomes legally recognized as an independent adult and takes responsibility for his or her own welfare, including medical care
                        </li>
                        <li>
                            96 Not Applicable
                        </li>
                        <li>
                            97 Unknown
                        </li>
                    </ul>
                    Is to be 0 (No) or not provided if the individual is an adult. <br />
                    <input type='text' id='txtChildrenDependency' name='txtChildrenDependency' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>56. Is Voluntarily In Treatment </span>
                    Indicate if the individual is voluntarily in treatment.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    Yes would indicate that the individual is voluntarily in treatment. <br />
                    No would indicate that the individual is involuntarily in treatment, for example, if the individual was court ordered into treatment. <br />
                    <input type='text' id='txtVoluntarily' name='txtVoluntarily' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>57. Arrests In Last 30 Days Number </span>
                    Indicate the number of arrests for any cause, within the last 30 days.
                    <ul>
                        <li>
                            Must be '1' if the arrests in the last 30 days is not known.
                        </li>
                    </ul>
                    <input type='text' id='txtArrests' name='txtArrests' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>58. Meets Criteria For Marchman Act </span>
                    Indicate if the individual meets the criteria for admission to a Marchman Act receiving facility.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    <input type='text' id='txtMarchmanAct' name='txtMarchmanAct' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>59. Marchman Act Code </span>
                    Indicate the type of Marchman Act that resulted in the individual being in treatment.
                    <ul>
                        <li>
                            1 for Involuntary Assessment
                        </li>
                        <li>
                            2 for Involuntary Treatment
                        </li>
                        <li>
                            3 for Involuntary Assessment and Treatment
                        </li>
                        <li>
                            7 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtMarchmanActCode' name='txtMarchmanActCode' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>60. Meets Criteria For Baker Act </span>
                    Indicate if the individual meets the criteria for admission to a Baker Act receiving facility.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            Civil State Hospitals is to use Code 1 for Yes.
                        </li>
                        <li>
                            Forensic State Hospitals is to use Code 0 for No.
                        </li>
                    </ul>
                    <input type='text' id='txtBakerAct' name='txtBakerAct' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>61. Baker Act Route </span>
                    Indicate the route that was used to determine whether the individual met the criteria for admission to a Baker Act receiving facility.
                    <ul>
                        <li>
                            1 for Involuntary Examinations thru Court
                        </li>
                        <li>
                            2 for Involuntary Examinations thru Law Enforcement
                        </li>
                        <li>
                            3 for Involuntary Examinations thru MH Professionals
                        </li>
                        <li>
                            4 for Voluntary Examination
                        </li>
                        <li>
                            7 for Unknown
                        </li>
                    </ul>
                    Civil State Hospitals is to use code 3 or 7. <br />
                    <input type='text' id='txtBakerActRoute' name='txtBakerActRoute' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>62. Baker Act Role </span>
                    Indicate the role of the person who determined the individual met the criteria for admission to a Baker Act receiving facility.
                    <ul>
                        <li>
                            01 for Judge
                        </li>
                        <li>
                            02 for Police Officer
                        </li>
                        <li>
                            03 for School Resource Officer
                        </li>
                        <li>
                            05 for Licensed Practitioner of the Healing Arts
                        </li>
                        <li>
                            06 for PhD/PsyD/Ed.D
                        </li>
                        <li>
                            07 for MD/DO
                        </li>
                        <li>
                            08 for Self
                        </li>
                        <li>
                            09 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtBakerActRole' name='txtBakerActRole' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>63. Baker Act Crisis Intervention Trained </span>
                    Indicate if the person who determined the individual met the criteria for admission to a Baker Act receiving facility was Crisis Intervention Trained.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtBakerActCrisis' name='txtBakerActCrisis' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>64. Baker Act School Setting </span>
                    Indicate if the event took place in a school setting.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    <input type='text' id='txtBakerActSchool' name='txtBakerActSchool' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>65. Baker Act Mobile Unit </span>
                    Indicate the person who determined the individual met the criteria
                    for admission to a Baker Act receiving facility was part of a Mobile Unit.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                    </ul>
                    <input type='text' id='txtBakerActMobile' name='txtBakerActMobile' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>66. Drug Court Ordered Code </span>
                    Indicate whether the individual was drug-court ordered to atend substance use treatment.
                    <ul>
                        <li>
                            0 for No
                        </li>
                        <li>
                            1 for Yes
                        </li>
                        <li>
                            3 for Unknown
                        </li>
                    </ul>
                    <input type='text' id='txtDrugCourt' name='txtDrugCourt' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>66. Drug Court Ordered Code </span>
                    Indicate whether the individual was drug-court ordered to atend substance use treatment.
                </p>
                <table>
                    <tr>
                        <td className='w-150'>01 Alachua </td>
                        <td className='w-150'>02 Baker </td>
                        <td className='w-150'>03 Bay </td>
                        <td className='w-150'>04 Bradford </td>
                        <td className='w-150'>05 Brevard </td>
                    </tr>
                    <tr>
                        <td className='w-150'>06 Broward </td>
                        <td className='w-150'>07 Calhoun </td>
                        <td className='w-150'>08 Charlote </td>
                        <td className='w-150'>09 Citrus </td>
                        <td className='w-150'>10 Clay </td>
                    </tr>
                    <tr>
                        <td className='w-150'>11 Collier </td>
                        <td className='w-150'>12 Columbia </td>
                        <td className='w-150'>13 Miami-Dade </td>
                        <td className='w-150'>14 DeSoto </td>
                        <td className='w-150'>15 Dixie </td>
                    </tr>
                    <tr>
                        <td className='w-150'>16 Duval </td>
                        <td className='w-150'>17 Escambia </td>
                        <td className='w-150'>18 Flagler </td>
                        <td className='w-150'>19 Franklin </td>
                        <td className='w-150'>20 Gadsden </td>
                    </tr>
                    <tr>
                        <td className='w-150'>21 Gilchrist </td>
                        <td className='w-150'>22 Glades </td>
                        <td className='w-150'>23 Gulf </td>
                        <td className='w-150'>24 Hamilton  </td>
                        <td className='w-150'>25 Hardee </td>
                    </tr>
                    <tr>
                        <td className='w-150'>26 Hendry </td>
                        <td className='w-150'>27 Hernando </td>
                        <td className='w-150'>28 Highlands </td>
                        <td className='w-150'>29 Hillsborough </td>
                        <td className='w-150'>30 Holmes </td>
                    </tr>
                    <tr>
                        <td className='w-150'>31 Indian River </td>
                        <td className='w-150'>32 Jackson </td>
                        <td className='w-150'>33 Jefferson </td>
                        <td className='w-150'>34 Lafayete </td>
                        <td className='w-150'>35 Lake </td>
                    </tr>
                    <tr>
                        <td className='w-150'>36 Lee </td>
                        <td className='w-150'>37 Leon </td>
                        <td className='w-150'>38 Levy </td>
                        <td className='w-150'>39 Liberty </td>
                        <td className='w-150'>40 Madison </td>
                    </tr>
                    <tr>
                        <td className='w-150'>41 Manatee </td>
                        <td className='w-150'>42 Marion </td>
                        <td className='w-150'>43 Martin  </td>
                        <td className='w-150'>44 Monroe </td>
                        <td className='w-150'>45 Nassau </td>
                    </tr>
                    <tr>
                        <td className='w-150'>46 Okaloosa </td>
                        <td className='w-150'>47 Okeechobee </td>
                        <td className='w-150'>48 Orange </td>
                        <td className='w-150'>49 Osceola </td>
                        <td className='w-150'>50 Palm Beach </td>
                    </tr>
                    <tr>
                        <td className='w-150'>51 Pasco </td>
                        <td className='w-150'>52 Pinellas </td>
                        <td className='w-150'>53 Polk </td>
                        <td className='w-150'>54 Putnam </td>
                        <td className='w-150'>55 St. Johns </td>
                    </tr>
                    <tr>
                        <td className='w-150'>56 St. Lucie </td>
                        <td className='w-150'>57 Santa Rosa </td>
                        <td className='w-150'>58 Sarasota </td>
                        <td className='w-150'>59 Seminole </td>
                        <td className='w-150'>60 Sumter </td>
                    </tr>
                    <tr>
                        <td className='w-150'>61 Suwannee </td>
                        <td className='w-150'>62 Taylor </td>
                        <td className='w-150'>63 Union </td>
                        <td className='w-150'>64 Volusia </td>
                        <td className='w-150'>65 Wakulla </td>
                    </tr>
                    <tr>
                        <td className='w-150'>66 Walton </td>
                        <td className='w-150'>67 Washington </td>
                        <td className='w-150'>99 Out of State </td>
                    </tr>
                    <input type='text' id='txtOrderedCode' name='txtOrderedCode' className='add-only' />
                </table>



            </div>
        </form>

    )
}

